export const TEST_TYPES = {
  MMPI: 'MMPI',
  NUMERIC_LOGIC: 'NUMERIC_LOGIC',
  VERBAL_LOGIC: 'VERBAL_LOGIC',
  NON_VERBAL_LOGIC: 'NON_VERBAL_LOGIC',
  PROF_INTERESTS: 'PROF_INTERESTS',
  MINIMULT: 'MINIMULT',
  COMPETENCES: 'COMPETENCES',
};
export const TEST_TYPES_TITLES = {
  MMPI: 'ММИЛ',
  VERBAL_LOGIC: 'Вербальная логика',
  NON_VERBAL_LOGIC: 'Невербальная логика',
  NUMERIC_LOGIC: 'Числовая логика',
  PROF_INTERESTS: 'Проф интересы',
  COMPETENCES: 'Компетенции',
};
export const TEST_TYPES_COLORS = {
  MMPI: '#483CB9',
  VERBAL_LOGIC: '#4db93c',
  NON_VERBAL_LOGIC: '#bd0f87',
  NUMERIC_LOGIC: '#c8c5e8',
  PROF_INTERESTS: '#f1c08e',
  MOSTURISM: '#243722',
  SSP: '#488f82',
  COMPETENCES: '#483CB9',
};
